export default __webpack_public_path__ + "static/media/cancer.a710d76d.svg";